// eslint-disable-next-line import-x/no-default-export
export {default} from '@bugsnag/js';
export * from '@bugsnag/js';
